import axios from 'axios';
import React, { Component } from 'react';

// Components

export class VideoList extends Component  {
  omittedVideoIds = ['-OnRjSwZmoY']

  state = {
    isLoaded: false, videos: []
  }

  shouldOmitVideo = (video) => {
    const { snippet } = video;

    if (!snippet) {
      return false;
    }

    const videoId = snippet.resourceId && snippet.resourceId.videoId;
    const normalizedTitle = (snippet.title || '').replace(/^#\s*/, '').trim();

    return this.omittedVideoIds.includes(videoId)
      || (
        normalizedTitle === 'iLIFE Journey'
        && snippet.publishedAt
        && snippet.publishedAt.startsWith('2026-07-22')
      );
  }

  componentDidMount() {
    const googleAPI = process.env.REACT_APP_GOOGLEAPI;
    const googleAPI_Key = process.env.REACT_APP_GOOGLEAPIKEY;

    axios.get(googleAPI+'/playlistItems', {
      params: {
        part: 'snippet,id',
        maxResults: this.props.count,
        key: googleAPI_Key,
        playlistId: 'PLx9J53NyYBSNiocDLwQM3obxJaG1LOUUS'
      }
    })
    .then(res => {
      const videos = (res.data.items || []).filter((video) => !this.shouldOmitVideo(video));

      this.setState({ videos, isLoaded: true })
      // console.dir(res);
    });
  }

  videoClick = (e) => {
    console.log(e.target.dataset.videoid);
    // window.location.href = '/event?eventid=' + e.target.dataset.eventid;
  }

  render() {
    const { isLoaded, videos } = this.state;
    // console.dir(this.state);

    return (
      <>
        {(isLoaded && videos != null) && (
          <aside className="videoList">
            <h2><i className="fab fa-youtube"></i> Past Event Videos</h2>

            {videos.map((v, index) =>
              <div className="video" key={ index }>
                <a href={ '/video?videoid=' + v.snippet.resourceId.videoId }>
                  <img src={ v.snippet.thumbnails.medium.url } alt={ v.snippet.title } />
                  <div className="vidInfo">
                    <p className="title"> { v.snippet.title }</p>
                    <p className="categ"> { v.snippet.channelTitle }</p>
                  </div>
                </a>
              </div>
            )}

            <p className="more"><a href="/allvideos">View All Videos <i className="fas fa-chevron-double-right"></i></a></p>

          </aside>
        )}
      </>
    );
  }
}

export default VideoList;